import { render, staticRenderFns } from "./ProductSettings.vue?vue&type=template&id=73049d92"
import script from "./ProductSettings.vue?vue&type=script&lang=js"
export * from "./ProductSettings.vue?vue&type=script&lang=js"
import style0 from "./ProductSettings.vue?vue&type=style&index=0&id=73049d92&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports